import { Component, OnInit } from '@angular/core';

import { LoadingController, ModalController, NavParams } from '@ionic/angular';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { APIService } from 'src/providers/apiservices/apiservices';
import { GlobalService, ToastColors } from 'src/providers/apiservices/globalservices';

export class SelectSearchableItem {
  id: string;
  texto: string;
  isVisivel: boolean = true;
  obj: any;

  constructor(id: string, texto: string, obj: any) {
    this.id = id;
    this.texto = texto;
    this.obj = obj;
  }
}

type User = {
  email: string;
  nomUsuario: string;
  login1: string;
  id: string;
  texto: string;
}
export class SelectSearchableItemPaginateApi {
  user: User;
  isVisivel: boolean = true;

  constructor(user: User) {
    this.user = user;
  }
}

@Component({
  selector: 'app-select-searchableapi',
  templateUrl: './select-searchable.page.html',
  styleUrls: ['./select-searchable.page.scss'],
})
export class SelectSearchablePageApi implements OnInit {
  
  titulo: string = '';
  filtro: string = '';
  filtroUpdate = new Subject<string>();
  lista: Array<SelectSearchableItemPaginateApi> = [];
  listaFiltrando: Array<SelectSearchableItemPaginateApi> = [];

  excludeCurrentUser: boolean = true;

  maxsize: number = 1;
  selecionados: Array<SelectSearchableItemPaginateApi> = [];
  provider: any;

  // refs provider
  
  idAtividade = null;
  idModulo = null;
  shopping = null;
  operacao = 'page'

  isLoadingSearch: boolean = false;

  constructor(
    public modalController: ModalController,
    private navParams: NavParams,
    private globalService:GlobalService,
    private loadingCtrl: LoadingController
    ) { 
      this.titulo = this.navParams.data.titulo;
      this.filtro = this.navParams.data.filtro;
      this.lista = this.navParams.data.lista;
      this.maxsize = this.navParams.data.maxsize;
      this.selecionados = [];
      let temp = this.navParams.data.selecionados;

      this.idAtividade = this.navParams.data.idAtividade;
      this.idModulo = this.navParams.data.idModulo;
      this.shopping = this.navParams.data.shopping;
      this.operacao = this.navParams.data.operacao;

      this.selecionados = temp;



      if(this.selecionados == undefined) {
        this.selecionados = [];
      }

      this.listaFiltrando = this.lista;

      this.search();
    }

  ngOnInit() {
    
    this.filtroUpdate
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe(_ => {
        this.search(false);
      });
  }

  dismiss(salvar: boolean) {
    this.modalController.dismiss({
      'selecionados': this.selecionados,
      'salvar': salvar
    });
  }

  async search(showLoading = true){


    if(this.provider)
    {
      this.isLoadingSearch = true;
      let loading = null;
      if(showLoading)
      {
        loading = await this.loadingCtrl.create({
          message: 'Aguarde...',
        });
      loading.present();
      } 

      this.provider.getMultiplanUsers({
        operacao: this.operacao,
        rowsPerPage: 100,
        search: this.filtro.trim(),
        orderBy: "nomUsuario",
        orderDirection: "asc",
        IdTipoUsuario__eq: 1,
        columns: "nomUsuario,login1,email",
        ...this.idAtividade && ({idAtividade: this.idAtividade}),
        ...this.idModulo && ({idModulo: this.idModulo}),
        ...this.shopping && ({shopping: this.shopping})
      })
      .then(res => {
        if(!res.error){
          let {data} = res;

          data = data.map(item => {
            if(item.email == APIService.UsuarioLogado.Usuario.email && this.excludeCurrentUser == true)
            {
              return null;
            }

            return new SelectSearchableItemPaginateApi(item);
          })
          .filter(x => x);

          this.lista = data;
          this.listaFiltrando = data;
        }
      })
      .finally(() => {
        this.isLoadingSearch = false;
        if(loading)
        {
          loading.dismiss();
        }
      })
    }
  }

  select(item : SelectSearchableItemPaginateApi) {
    if(this.maxsize === 1 && this.selecionados.length > 0)
    {
      const _previousItem = this.selecionados[0];

      if(_previousItem)
      {

        const _previousItemIndex = this.lista.findIndex(x => x.user.id === _previousItem.user.id);

        if(_previousItemIndex !== -1)
        {
          this.lista[_previousItemIndex].isVisivel = true;
        }
      }

      this.selecionados = [];
      this.selecionados.push(item);
      item.isVisivel = false;
      return;
    }

    if(this.selecionados.length >= this.maxsize) {
      this.globalService.presentToast('Selecione no máximo ' + this.maxsize + " items!", ToastColors.warning);
    } else {

      const _previousItem = this.selecionados.find(u => u.user.id == item.user.id);

      if(_previousItem)
      {
        const _previousItemIndex = this.lista.findIndex(x => x.user.id === _previousItem.user.id);

        if(_previousItemIndex !== -1)
        {
          this.lista[_previousItemIndex].isVisivel = true;
        }
      }

      this.selecionados.push(item);
      
      item.isVisivel = false;
    }
  }

  deselect(item : SelectSearchableItemPaginateApi){
    // item.isVisivel = true;
    let selected = this.listaFiltrando.find(element => element.user.id === item.user.id);
    if(selected)
      selected.isVisivel = true;
      
    this.selecionados = this.selecionados.filter(function(a){return a.user.id !== item.user.id});
  }
}
